import { Organisation } from '@/features'
import { shareOrganisation } from '@/utils'
import { useModal } from '@codeleap/common'
import React from 'react'

export function PerTopicEngagementScore({ organisation, blurred }) {
  const scoreModal = useModal()
  const [topicId, setTopicId] = React.useState<string | null>(null)

  return (
    <>
      <Organisation.PerTopicEngagementScore
        organisation={organisation}
        blurred={blurred}
        onExpand={topic => {
          scoreModal.toggle()
          setTopicId(topic?.value || null)
        }}
      />
      <Organisation.ScoreModal
        {...scoreModal}
        organisationId={organisation?.id}
        topicId={topicId}
      />
    </>
  )
}

export function ReviewButtons({ organisation }) {
  const isMyOrganisation = Organisation.useIsMyOrg(organisation?.id)

  return (
    <Organisation.OrgReviewButtons
      onShare={() => shareOrganisation(organisation)}
      isMyOrganisation={isMyOrganisation}
    />
  )
}
